import { defineComponent as _defineComponent } from 'vue'
import BCXTable from '@/components/BCXTable.vue';
import { computed } from 'vue';
import useI18n from '@/mixins/useI18n';
import useFormattedDateTime, { TimeFormatting } from '@/mixins/useFormattedDateTime';
import useResponsiveness from '@/mixins/useResponsiveness';
import MyProjectsContractDetails from '@/views/my-projects/components/contract/contractDocuments/MyProjectsContractDetails.vue';
import useContract from '@/views/my-projects/composables/useContract';


export default /*#__PURE__*/_defineComponent({
  __name: 'MyProjectsContractDocumentTable',
  setup(__props) {

const { t } = useI18n();
const fields = ['title', 'customer', 'contractor', 'changed'];
const sortableFields = ['title', 'changed'];
const { isMobileWidth } = useResponsiveness();

const { contractDetail, openContractDocumentId, toggleOpenContractDocument } = useContract();
const contractDocuments = computed(() => contractDetail.value?.documents ?? []);
const isOpenContractDocument = (id: string) => openContractDocumentId.value === id;

const headerTitles = computed(() => [
  `${t('contracts.contract.contractDocuments.table.columns.title')}`,
  `${t('contracts.contract.contractDocuments.table.columns.customer')}`,
  `${t('contracts.contract.contractDocuments.table.columns.contractor')}`,
  `${t('contracts.contract.contractDocuments.table.columns.changed')}`,
]);

const sortCallback = (fieldName: string, obj:any) => {
  switch (fieldName) {
    case 'title': return obj.title;
    case 'customer': return +obj.customerSignature;
    case 'contractor': return +obj.contractorSignature;
    case 'changed': return obj.lastChanged;
  }
  return 0;
};

const { getFormattedTimeByAge } = useFormattedDateTime();

const getSignedString = (isSigned: boolean) => t(`contracts.contract.contractDocuments.table.${isSigned ? 'signed' : 'unsigned'}`);

const displayCallback = (fieldName: string, obj: any) => {
  switch (fieldName) {
    case 'customer': return getSignedString(obj.signedByClient);
    case 'contractor': return getSignedString(obj.signedByContractor);
    case 'changed': return getFormattedTimeByAge(obj.lastChanged, TimeFormatting.ChatMessageOverview);
  }
  return obj[fieldName];
};


return { __sfc: true,t, fields, sortableFields, isMobileWidth, contractDetail, openContractDocumentId, toggleOpenContractDocument, contractDocuments, isOpenContractDocument, headerTitles, sortCallback, getFormattedTimeByAge, getSignedString, displayCallback, BCXTable, MyProjectsContractDetails }
}

})